import { useEffect, useRef } from "react";
import { toast } from "sonner";
import api from "../lib/api";
import { useAuth } from "../lib/AuthContext";
import { PENDING_KEY } from "./SignInToSaveModal";

/**
 * Mounted at the app root. When AuthContext.user transitions from null to a real user
 * (typical Google/email login return), we check localStorage for a pending
 * "sign in to save" payload and finish the save automatically.
 */
export default function PendingSaveHandler() {
  const { user, loading } = useAuth();
  const flushed = useRef(false);

  useEffect(() => {
    if (loading || !user || flushed.current) return;
    let raw;
    try {
      raw = localStorage.getItem(PENDING_KEY);
    } catch (readErr) {
      console.warn("Could not read pending save:", readErr);
      return;
    }
    if (!raw) return;
    flushed.current = true;
    let payload;
    try {
      payload = JSON.parse(raw);
    } catch (parseErr) {
      console.warn("Corrupt pending save payload:", parseErr);
      payload = null;
    }
    try {
      localStorage.removeItem(PENDING_KEY);
    } catch (removeErr) {
      console.warn("Could not clear pending save:", removeErr);
    }
    if (!payload || !payload.url || !payload.title) return;

    (async () => {
      try {
        await api.post("/web-deals/save", payload);
        toast.success(`Saved "${String(payload.title).slice(0, 40)}" ✓`);
      } catch (saveErr) {
        console.warn("Pending save failed", saveErr);
        toast.error("Could not save the deal — try clicking the bookmark again.");
      }
    })();
  }, [user, loading]);

  return null;
}
